import axios from 'axios';
import cryptoJs from 'crypto-js'
import Nprogress from 'nprogress';
import 'nprogress/nprogress.css';
import getToken from '../lib/getToken';
import { youXunApi } from '../lib/youxunAPI'
import router from '../router/index';
import { MessageBox } from 'element-ui';
var $base64 = require("js-base64").Base64;
import AES from '../lib/encryption';
var AesTop = '';
console.log(process.env.NODE_ENV);
const apiUrl = process.env.API_URI;
var data_ = {
  AppName:'ArtPlatform',
  AccessKeyId:'e10adc3949ba59abbe56e057f20f883e',
  Env:'web',
  Ver:'1.0',
}
let http = axios.create({
    timeout: 30 * 1000,
    baseURL: `${apiUrl}/api/app/`,
    // withCredentials: true,
    headers: {
      'Content-Type':'application/json;charset=utf-8',
      'userToken':$base64.decode(window.localStorage.getItem('userToken-web')),
    },
    transformRequest: [function (data) {
      return JSON.stringify(data)
    }]
  });
  http.interceptors.request.use(config => {
    Nprogress.start()
    if(config.url.indexOf('/login')!=-1||config.url.indexOf('/getToken')!=-1){
      config.headers.userToken = '0'
    }else{
      config.headers.userToken = $base64.decode(window.localStorage.getItem('userToken-web'))
    }
    return config;
  }, function (error) {
      return Promise.reject(error);
  });
  http.interceptors.response.use(config => {
      Nprogress.done()
      if (config.data.code == 2||config.data.code == 3) {
        getToken.getToken_http()
        MessageBox.error('网络错误，请重试')
      }else if(config.data.code == 4) {
        MessageBox.alert('登录过期，请重新登录。', '提示', {
          confirmButtonText: '确定',
          center: true,
          type: 'error',
          callback: action => {
            sessionStorage.removeItem('userName');
            sessionStorage.removeItem('routePath');
            if(sessionStorage.getItem('orgId')){//测评
                router.push({
                  path: `/${sessionStorage.getItem('orgId')}/login`,
                  query: {
                      phone:sessionStorage.getItem('phone')? sessionStorage.getItem('phone'):''
                  }
                })
            }else{
                router.push({
                  path: '/login',
                })
            }
          }
        });
      }else{
        return config
      }
    },error => {
      Nprogress.done()
      return error
    }
  );
  function apiAxios(method, url, params, response) {
    data_['Timestamp'] = +new Date()
    let Expiry = $base64.decode(localStorage.getItem('tokenExpiryTime-web'))
    let nn = +new Date();
    if((!Expiry||Expiry==null||Number(nn) >= Number(Expiry))&&url.indexOf('/login')==-1){
      let url_t = `${apiUrl}/api/app/account/getToken`
      data_['Timestamp'] = +new Date()
      console.log(data_.Timestamp)
      let keys = AES.generatekey('0',data_.Timestamp);
      let encrypts = AES.encrypt(JSON.stringify({'uid':Number($base64.decode(window.localStorage.getItem('uid-web')))}),keys);
      console.log('getToken',keys,encrypts,{'uid':Number($base64.decode(window.localStorage.getItem('uid-web')))})
      axios.post(url_t+HmacSHA256(data_,url_t),{data:encrypts},{headers: {'Content-Type':'application/json;charset=utf-8',"userToken":'0'}}
      ).then(response => {
        let res = {data:JSON.parse(AES.decrypt(response.data.data,keys))}
        console.log(res)
        let v = res.data
        if (v.code == 0) {
            window.localStorage.setItem('userToken-web',$base64.encode(v.data.token));
            window.localStorage.setItem('tokenExpiryTime-web',$base64.encode((+new Date()+(v.data.tokenExpiryTime*1000))));
        }
      })
    }
    let token_ed = $base64.decode(window.localStorage.getItem('userToken-web'))
    if(url=='/v1/account/login') token_ed='0' //登录时token必须为0
    let prs = ''
    let keys,encrypts;
    if(!AesTop){
      keys = AES.generatekey(token_ed,data_.Timestamp);
      encrypts = AES.encrypt(JSON.stringify(params),keys);
      prs = {data:encrypts}  
    }else{ prs = params }
    http({
      method: method,
      url: (url+HmacSHA256(data_,url))+(AesTop?'&Aes='+AesTop:''),
      data: method === 'POST' || method === 'PUT' ? prs : null,
      params: method === 'GET' || method === 'DELETE' ? prs : null,
    }).then(function (res) {
      if(!AesTop){
        response({data:JSON.parse(AES.decrypt(res.data.data,keys))});
      }else{response(res)}
    }).catch(function (err) {
      response(err);
    })
  }

//HmacSHA256加密签名
function sha256(obj,url){
  if(!$base64.decode(window.localStorage.getItem('secretKey-web'))) return 0;
  let map = new Map();
  let prm = Object.keys(obj).map(function(k) {
      map.set(k, obj[k]);
      return encodeURIComponent(k) + "=" + encodeURIComponent(obj[k]);
    }).join('&');
    var _prm = 'POST\n'+prm;
    var esa_prm = cryptoJs.HmacSHA256(_prm,$base64.decode(window.localStorage.getItem('secretKey-web'))).toString();
    var result = $base64.encode(String(esa_prm));
    return result
  }

function HmacSHA256(obj,url){
  var oll = sha256(obj,url)
  let map = new Map();
  let prm = Object.keys(obj).map(function(k) {
    map.set(k, obj[k]);
    return encodeURIComponent(k) + "=" + encodeURIComponent(obj[k]);
    }).join('&');
    var str = '?'+prm+'&Signature='+oll
    return str
  }

  export default {
    get: function (url, params, response) {
      return apiAxios('GET', url, params, response)
    },
    post: function (url, params, response) {
      return apiAxios('POST', url, params, response)
    },
    put: function (url, params, response) {
      return apiAxios('PUT', url, params, response)
    },
    delete: function (url, params, response) {
      return apiAxios('DELETE', url, params, response)
    },
  }


// WEBPACK FOOTER //
// ./src/api/index.js